const productCards = document.querySelectorAll('[product-card]');
const activeProductCards = [];

productCards.forEach(productCard => {
  const hoverVideo = productCard.querySelector('[product-hover-video]');

  if (!hoverVideo) {
    return;
  }

  const productCardLink = productCard.querySelector('[product-card-link]');

  productCardLink.addEventListener('click', (event) => {
    const mobileBreakpoint = '(max-width: 777px)';
    const isMobileDevices = window.matchMedia(mobileBreakpoint).matches;
    const isActive = productCard.classList.contains('is-active');

    if (!isMobileDevices || isActive) {
      return;
    }

    productCard.classList.add('is-active');

    activeProductCards.push(productCard);

    event.preventDefault();
  });
});

document.addEventListener('click', (event) => {
  if (activeProductCards.length === 0 || event.target.closest('[product-card]')) {
    return;
  }

  activeProductCards.forEach(activeProductCard => activeProductCard.classList.remove('is-active'));

  activeProductCards.length = 0;
});

const rebuyCartEvents = ['rebuy:cart.add', 'rebuy:cart.change'];

rebuyCartEvents.forEach(eventName => {
  document.addEventListener(eventName, (event) => {
    const { cart } = event.detail;

    const itemCount = cart.cart.item_count;

    document.querySelectorAll('[data-count]').forEach(counter => {
      counter.setAttribute('data-count', itemCount);
      counter.querySelector('[data-ajax-cart-bind="item_count"]').textContent = itemCount;
    });
  });
});

// Bundle discount block — toggle onetime / subscription message
(() => {
  const onetimeMsg = document.querySelector('[data-bf-purchase-type="onetime"]');
  const subMsg = document.querySelector('[data-bf-purchase-type="subscription"]');
  if (!onetimeMsg && !subMsg) return;

  const update = () => {
    const sp = document.querySelector('input[name="selling_plan"]');
    const isSub = sp && sp.value && sp.value !== '0';
    if (onetimeMsg) onetimeMsg.hidden = isSub;
    if (subMsg) subMsg.hidden = !isSub;
  };

  document.addEventListener('change', update);
  document.addEventListener('DOMContentLoaded', update);
  update();
})();

// Strip discount percentage from Shopify subscriptions selling plan dropdown options
(() => {
  const pctPattern = /,?\s*\(?(?:save\s+\d+(?:\.\d+)?%|\d+(?:\.\d+)?%\s*(?:off|discount)?)\s*\)?/gi;

  const strip = (el) => {
    if (!el.children.length && pctPattern.test(el.textContent)) {
      pctPattern.lastIndex = 0;
      el.textContent = el.textContent.replace(pctPattern, '').trim();
    }
  };

  const init = () => {
    document.querySelectorAll('option, [data-selling-plan] label, shopify-selling-plan-picker option').forEach(strip);
  };

  const observer = new MutationObserver((mutations) => {
    mutations.forEach(m => m.addedNodes.forEach(node => {
      if (node.nodeType !== 1) return;
      node.querySelectorAll('option, [data-selling-plan] label').forEach(strip);
      strip(node);
    }));
    init();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', init);
  init();
})();

// Keep compare_at_price in the strikethrough when any subscription app updates prices
(() => {
  const enforce = () => {
    document.querySelectorAll('s.price-item--regular[data-compare-price]').forEach(el => {
      const correct = el.getAttribute('data-compare-price');
      if (el.textContent.trim() !== correct) el.textContent = correct;
    });
  };
  const cfg = { childList: true, subtree: true, characterData: true };
  const obs = new MutationObserver(() => { obs.disconnect(); enforce(); obs.observe(document.body, cfg); });
  obs.observe(document.body, cfg);
  enforce();
})();
